import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getServiceDuration } from '../services/selectors';

const mapStateToProps = (state, ownProps) => ({
  serviceDuration: getServiceDuration(state, ownProps.params.serviceId),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithServiceDuration.js